/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import { useProjectsAnalyticsL2 } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/controllers/use-projects-analytics-l2/index.tsx';
import { RECENT_SECTION } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/project-content-section.tsx';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection, MenuSectionHeading } from '@atlaskit/side-nav-items/menu-section';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import type { RecentItemsType } from '../types.tsx';

const recent = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.recent',

	defaultMessage: 'Recent',
	description: 'Message for recent heading in the projects menu items',
});

export function RenderRecentSection({
	recentItems,
	canCreateProject,
}: {
	recentItems: RecentItemsType;
	canCreateProject: boolean | undefined | null;
}): false | React.JSX.Element {
	const { formatMessage } = useIntl();
	const { sendProjectMenuContentSectionAnalyticsEvent } = useProjectsAnalyticsL2();

	useEffect(() => {
		sendProjectMenuContentSectionAnalyticsEvent({
			projectSection: RECENT_SECTION,
			canCreateProject,
		});
	}, [canCreateProject, sendProjectMenuContentSectionAnalyticsEvent]);

	return (
		recentItems.hasItems && (
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.recent-section.recent-section">
				<MenuSection>
					<MenuSectionHeading>{formatMessage(recent)}</MenuSectionHeading>
					<MenuList>{recentItems.list}</MenuList>
				</MenuSection>
			</MenuListItem>
		)
	);
}
